export const Constants = {
    PLAY_STORE: 'https://play.google.com/store/apps/details?id=com.aryo.aryoleads'
}